import {
  Link,
  LinkOwnProps,
  SxProps,
  Theme,
  useMediaQuery,
} from "@mui/material"
import theme from "@skistarab/mui-theme"

interface LinkButtonHybridProps {
  children: React.ReactNode
  onClick: () => void
  color?: LinkOwnProps["color"]
  sx?: SxProps<Theme>
}

const LinkButtonHybrid = ({
  children,
  onClick,
  sx,
  color,
}: LinkButtonHybridProps) => {
  const isTablet = useMediaQuery(theme.breakpoints.up("md"))
  return (
    <Link
      component="button"
      type="button"
      aria-haspopup="dialog"
      variant={isTablet ? "body2" : "body3"}
      fontWeight={600}
      color={color || "secondary"}
      sx={{
        pb: 1.9,
        pt: 1.9,
        ...sx,
      }}
      onClick={onClick}
    >
      {children}
    </Link>
  )
}

export default LinkButtonHybrid
